import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ConfiguracoesMiaService extends ServerService {

  constructor(private httpCliente: HttpClient) {
    super(httpCliente);
  }

  async obtenhaConfiguracoes() {
    return this.obtenha('/configuracoesMia', {});
  }

  async salveConfiguracoes(configuracoes: any) {
    return this.salve('/configuracoesMia', configuracoes);
  }
}
